import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { fetchDriverContactRules } from '@/data/api';
import { getApiErrorMessage } from '@/lib/api';
import { useAuth } from '@/contexts/AuthContext';

const DriverRulesContext = createContext(null);

export const DriverRulesProvider = ({ children }) => {
  const { user, ready } = useAuth();
  const [rules, setRules] = useState([]);
  const [rulesLoading, setRulesLoading] = useState(false);
  const [rulesError, setRulesError] = useState('');

  const reloadRules = useCallback(async () => {
    setRulesLoading(true);
    setRulesError('');

    try {
      setRules(await fetchDriverContactRules());
    } catch (error) {
      setRules([]);
      setRulesError(getApiErrorMessage(error, 'Nao foi possível carregar as regras.'));
    } finally {
      setRulesLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!ready) return;
    // A first-login session is intentionally limited to account activation.
    // Protected rule endpoints are only available once activation is complete.
    if (!user || user.mustChangePassword || !user.emailVerified) {
      setRules([]);
      setRulesError('');
      setRulesLoading(false);
      return;
    }
    reloadRules();
  }, [ready, reloadRules, user]);

  return (
    <DriverRulesContext.Provider value={{ rules, setRules, rulesLoading, rulesError, reloadRules }}>
      {children}
    </DriverRulesContext.Provider>
  );
};

export const useDriverRules = () => {
  const ctx = useContext(DriverRulesContext);
  if (!ctx) throw new Error('useDriverRules must be used within DriverRulesProvider');
  return ctx;
};
